import { useState, useEffect } from 'react';
import Icon from '@components/Icon';
import { InputNumber, Button, Tooltip } from 'antd';

export default ({ frameWidth, frameHeight, type, onSet }) => {
    const [width, setWidth] = useState('');
    const [height, setHeight] = useState('');
    const setAuto = () => {
        onSet({ type: 'auto', title: '自动' });
    };
    const setCustom = () => {
        onSet({ type: 'custom', title: '自定义', width, height });
    };
    useEffect(() => {
        if (type === 'custom') {
            setWidth(frameWidth);
            setHeight(frameHeight);
        } else {
            setWidth('');
            setHeight('');
        }
    }, [type]);
    return (
        <div className='flex gap-2 items-center py-2 font-normal'>
            <InputNumber
                min={1}
                value={width}
                onChange={setWidth}
                placeholder={frameWidth}
                prefix={<span className='opacity-60 mx-1 text-purple-600 dark:text-purple-400'>宽</span>}
                className='flex-1'
                controls={false}
                style={{ borderColor: '#d1d5db', borderRadius: '0.375rem' }}
            />
            <span className='text-xs opacity-50'>x</span>
            <InputNumber
                min={1}
                value={height}
                onChange={setHeight}
                placeholder={frameHeight}
                prefix={<span className='opacity-60 mx-1 text-purple-600 dark:text-purple-400'>高</span>}
                className='flex-1'
                controls={false}
                style={{ borderColor: '#d1d5db', borderRadius: '0.375rem' }}
            />
            <Tooltip title="应用自定义尺寸">
                <Button
                    type='primary'
                    shape='circle'
                    icon={<Icon.Check size={18} useFa={true} />}
                    disabled={!width || !height}
                    onClick={setCustom}
                    className='bg-purple-600 hover:bg-purple-700 border-purple-600 hover:border-purple-700'
                ></Button>
            </Tooltip>
            <Tooltip title="自适应图片尺寸">
                <Button
                    type='default'
                    shape='circle'
                    icon={<Icon.Maximize size={18} useFa={true} className={type === 'auto' ? 'text-gray-400' : 'text-purple-600 dark:text-purple-400'} />}
                    disabled={type === 'auto'}
                    onClick={setAuto}
                    className={type === 'auto' ? 'border-gray-300' : 'border-purple-500 hover:border-purple-600 dark:border-purple-400 dark:hover:border-purple-500'}
                ></Button>
            </Tooltip>
        </div>
    );
};
